import React, { SVGProps } from 'react';

const Logo = (props: SVGProps<SVGSVGElement>) => <div>Future Admin</div>;

export default Logo;
